import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { StyleProp, Text, TouchableOpacity, View, ViewStyle } from 'react-native'
import { styles } from './styles'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { white } from '../../theme/colors'
import { useTranslation } from 'react-i18next'

interface Props {
  item: { id: number | string; name: string }
  isCheck: boolean
  onPress: (value: number | string) => void
  invertLabel?: boolean
  containerStyle?: StyleProp<ViewStyle>
  checkStyle?: {
    active: StyleProp<ViewStyle>
    inactive: StyleProp<ViewStyle>
  }
}

export const CheckBox = ({
  isCheck,
  onPress,
  item,
  invertLabel,
  containerStyle,
  checkStyle,
}: Props) => {
  const { t } = useTranslation()

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={() => onPress(item.id)}
        style={[
          styles.checkContainer,
          containerStyle,
          invertLabel && {
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
          },
        ]}
      >
        <View
          style={[
            styles.check,
            isCheck && styles.checkActive,
            checkStyle && checkStyle.inactive,
            isCheck && checkStyle && checkStyle.active,
          ]}
        >
          <FontAwesomeIcon icon={faCheck} color={white} size={20} />
        </View>
        <Text style={[styles.label]}>{t(item.name)}</Text>
      </TouchableOpacity>
    </View>
  )
}
